import React from "react";
import { Button } from "react-bootstrap";

export default function SubmitButton(props: any) {
    let { disabled, text } = props;
    return (
        <Button
            type="submit"
            variant='outline-primary'
            disabled={disabled ?? false}>
            {text ?? "Сохранить"}
        </Button>
    );
}